import { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";

import useCustomSelector from "@redux/hooks/useCustomSelector";

import useActionCreator from "../../../../../../redux/hooks/useActionCreator";
import { BrandCreateType } from "@type/inventory/brand";
import {
  ErrorModal,
  InputTextVertical,
  SuccessModal,
  VerticalInputFormLayout,
} from "@components";
import { BrandState } from "@reducers/types/inventory/brand-satate";

export default function BrandForm({
  settingsBrandState,
}: {
  settingsBrandState: BrandState;
}) {
  const [brandId, setBrandId] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm<BrandCreateType>();

  const {
    getSingleData,
    createSuccess,
    deleteSuccess,
    createError,
    deleteError,
    updateError,
    updateSuccess,
  } = settingsBrandState;
  const { data } = getSingleData || {};

  const { brandCreateActionHandler, brandUpdateActionHandler } =
    useActionCreator();

  const onSubmit: SubmitHandler<BrandCreateType> = (data) => {
    if (brandId) {
      brandUpdateActionHandler(brandId, data);
    } else {
      brandCreateActionHandler(data);
    }
  };

  const [successSubtitle, setSuccessSubtitle] = useState<string>("");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const createSuccessAction = () => {
    reset();
    setIsSuccessModalOpen(false);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  useEffect(() => {
    if (createSuccess) {
      setSuccessSubtitle("You have created an inventory settings brand");
      setIsSuccessModalOpen(true);
    }

    if (deleteSuccess) {
      setSuccessSubtitle("You have deleted an inventory settings brand");
      setIsSuccessModalOpen(true);
    }

    if (updateSuccess) {
      setSuccessSubtitle("You have updated an inventory settings brand");
      setIsSuccessModalOpen(true);
      setBrandId("");
      reset();
    }

    if (createError || deleteError || updateError) {
      setSuccessSubtitle("");
      setIsErrorModalOpen(true);
    }
  }, [
    createSuccess,
    deleteSuccess,
    createError,
    deleteError,
    updateError,
    updateSuccess,
  ]);

  const resetAction = () => {
    reset();
    setBrandId("");
  };

  useEffect(() => {
    if (data) {
      setValue("name", data.name);
      setBrandId(data.id);
    }
  }, [data, setValue]);

  useEffect(() => resetAction(), []);

  return (
    <div>
      <VerticalInputFormLayout
        label="INVENTORY_SETTINGS.BRAND.FORM.HEADER"
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        isUpdate={!!brandId}
        loading={
          settingsBrandState.isCreateLoading ||
          settingsBrandState.isUpdateLoading ||
          settingsBrandState.isGetSingleLoading ||
          settingsBrandState.isDeleteLoading
        }
        cancelAction={resetAction}
      >
        <InputTextVertical
          label="INVENTORY_SETTINGS.BRAND.FORM.FIELDS.BRAND"
          register={{
            ...register("name", {
              required: "Brand name is required",
            }),
          }}
          error={errors}
          required
          cols={3}
        />
      </VerticalInputFormLayout>

      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
          subtitle={successSubtitle}
        />
      )}

      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
    </div>
  );
}
